export const ALLOCATIONS_TABLE_TYPES = {
  PROJECT: 'PROJECT',
  ACTOR: 'ACTOR',
  DEAL: 'DEAL',
};
